import React, { Component } from 'react';
import axios from "axios";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { Link } from 'react-router-dom';

import Loader from './utils/Loadersmall';

class Geforcertxpc extends Component {

    constructor(props) {
        super(props);
        this.state = {
            brandsList:'',
            serviceCheck:false,
        }   
    }

    async componentDidMount() {
        const params = new URLSearchParams();
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/brands',params);
           let resVal=response.data;
            if(resVal.status==='success'){
                this.setState({brandsList:resVal.data});
                this.setState({serviceCheck:true});
            }else{
                NotificationManager.error(resVal.message);
                this.setState({serviceCheck:true});
            }
        } catch (error) {
          console.error(error);
        }
    }

    render() {

        if(this.state.serviceCheck===false)
        return (<Loader/>);

        return (

            <div class="ps-about">

                <div class="ps-about__content">
                    <section class="ps-about__project brandPagebg">
                        <div class="container">
                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <img src="/assets/img/brand1.png" alt="Geforce-rtx-pcs"/>
                                </div>
                                <div class="col-12 col-md-12">
                                    <h2 class="brandpromoTitle text-center">BETTER HARDWARE</h2>

                                    <h5 class="brandpromoSubTitle text-center">Equip yourself for the most challenging game with GeForce. </h5>

                                    <div class="row">
                                            <div class="col-12 col-md-4">
                                                <div class="brandpromoBox">
                                                        <h3>Good</h3>
                                                        <img src="http://devapp.byos.in/backend/uploads/product-images/ec00db4dffaccb95fdeb517302b85d78.jpg" class="brandPromoImage"/>
                                                        <ul>
                                                            <li>Intel Core i3 12100F (4 Core, 8 Threads, Up to 4.3 GHz)</li>
                                                            <li>MSI PRO B660M-A DDR4</li>
                                                            <li>G.Skill 8GB Ripjaws V DDR4 3200MHz</li>
                                                            <li>Nvidia GeForce RTX 3050 8GB (MSI/Inno3D)</li>
                                                            <li>XPG 256GB S5 NVMe M.2 SSD</li>
                                                            <li>1TB SATA HDD 7200 RPM</li>
                                                            <li>Deepcool PM650D</li>
                                                            <li>Deepcool Matrexx 40 3F</li>
                                                            <li>Deepcool GAMMAXX L240 A-RGB 240 mm AIO Liquid CPU Cooler</li>
                                                            <li>30 Days Microsoft Windows 10 Professional 64-Bit Trial</li>
                                                        </ul>
                                                        <a href="https://byos.in/details/NQ==/Intel%20Core%20I3-12100F" class="brandpromoAction">BUY NOW</a>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="brandpromoBox">
                                                        <h3>Better</h3>
                                                        <img src="http://devapp.byos.in/backend/uploads/product-images/cc95baf7178750ebedb8cfd2eedec162.jpg" class="brandPromoImage"/>
                                                        <ul>
                                                            <li>Ryzen 7 5800X (8Core, 16 Threads, Up to 4.7 GHz)</li>
                                                            <li>MSI B550 Gaming Plus</li>
                                                            <li>G.Skill 16GB Ripjaws V DDR4 3200MHz</li>
                                                            <li>Nvidia GeForce RTX 3060 12GB (MSI/Inno3D)</li>
                                                            <li>XPG 512GB S11 Pro NVME M.2 SSD</li>
                                                            <li>1TB SATA HDD 7200 RPM</li>
                                                            <li>Deepcool PM750D</li>
                                                            <li>Lian Li Lancool II Black</li>
                                                            <li>Deepcool CASTLE 240 EX A-RGB </li>
                                                            <li>30 Days Microsoft Windows 10 Professional 64-Bit Trial</li>
                                                        </ul>
                                                        <a href="https://byos.in/details/MTE=/Amd%20Ryzen%207%205800X%20Processor" class="brandpromoAction">BUY NOW</a>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <div class="brandpromoBox">
                                                        <h3>Best</h3>
                                                        <img src="http://devapp.byos.in/backend/uploads/product-images/b32f5305217e5803cfdefe8acb40f759.jpg" class="brandPromoImage"/>
                                                        <ul>
                                                            <li>Intel Core i7 12700K (12 Core, 20 Threads, Up to 5.0 GHz)</li>
                                                            <li>MSI MAG Z690 TOMAHAWK WIFI DDR5</li>
                                                            <li>G.Skill 32GB (16GB*2) Trident Z5 RGB Black DDR5 5600MHz</li>
                                                            <li>Nvidia GeForce RTX 3070 8GB (MSI/Inno3D)</li>
                                                            <li>XPG 1TB S11 Pro NVME M.2 SSD</li>
                                                            <li>1TB SATA HDD 7200 RPM</li>
                                                            <li>Deepcool DQ850-M V2</li>
                                                            <li>Phanteks Eclipse P500A TG DRGB Satin Black</li>
                                                            <li>Deepcool CASTLE 360 EX A-RGB</li>
                                                            <li>30 Days Microsoft Windows 10 Professional 64-Bit Trial</li>
                                                        </ul>
                                                        <a href="https://byos.in/details/MTI=/Intel%20Core%20I7-12700K%20Processor" class="brandpromoAction">BUY NOW</a>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12">
                                    <img src="/assets/img/brand2.png" alt="Geforce-rtx-pcs"/>
                                </div>
                                <div class="col-12 col-md-12">
                                    <img src="/assets/img/brand3.png" alt="Geforce-rtx-pcs"/>
                                </div>
                                <div class="col-12 col-md-12">
                                    <img src="/assets/img/brand4.png" alt="Geforce-rtx-pcs"/>
                                </div>
                                <div class="col-12 col-md-12">
                                    <img src="/assets/img/brand5.png" alt="Geforce-rtx-pcs"/>
                                </div>
                            </div>
                        </div>
                    </section>
        
                </div>
            
            </div>
    
        );
    }
}

export default Geforcertxpc;